import React from "react";
import { CheckCircle } from "lucide-react";

const QUESTIONS = [
  "Where can AI draft safely?",
  "Where must human review stay explicit?",
  "What needs to be logged?",
  "What evidence should be preserved?",
  "What should be validated before broader rollout?",
];

export default function ValidationAIImpact() {
  return (
    <section className="py-14 sm:py-16 bg-muted/30 border-b border-border">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight mb-5">
          AI can speed up validation work. That does not mean it is ready for regulated use.
        </h2>
        <p className="text-base text-muted-foreground leading-relaxed mb-8 max-w-3xl">
          Many labs are experimenting with AI in validation summaries, deviations, CAPAs, SOP updates, and review workflows. The real question is not whether AI can draft faster, but whether your process has the handoff points, review controls, traceability, and evidence trail needed to support compliant use.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {QUESTIONS.map((q) => (
            <div key={q} className="flex items-start gap-2.5 bg-card border border-border rounded-lg p-4">
              <CheckCircle className="w-4 h-4 text-secondary shrink-0 mt-0.5" />
              <span className="text-sm text-foreground">{q}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}